<div class="dialog-header">
  <span class="dialog-title">Passwort ändern</span>
  <mat-icon class="dialog-close" (click)="$event.stopPropagation(); tryClose()">close</mat-icon>
</div>
<div class="dialog-body">
  <label class="field-label">Aktuelles Passwort*</label>
  <div class="password-field">
    <input class="field-input" [class.field-error]="form.controls['old_password'].invalid && form.controls['old_password'].touched"
           [formControl]="$any(form.controls['old_password'])" [type]="hideOld ? 'password' : 'text'"
           autocomplete="current-password">
    <mat-icon class="password-toggle" (click)="hideOld = !hideOld"
              [attr.aria-label]="hideOld ? 'Passwort anzeigen' : 'Passwort verbergen'"
              role="button" tabindex="0"
              (keydown.enter)="hideOld = !hideOld" (keydown.space)="$event.preventDefault(); hideOld = !hideOld">
      {{ hideOld ? 'visibility_off' : 'visibility' }}
    </mat-icon>
  </div>
  @if (form.controls['old_password'].invalid && form.controls['old_password'].touched) {
    <p class="validation-error">Aktuelles Passwort ist ein Pflichtfeld.</p>
  }

  <label class="field-label">Neues Passwort*</label>
  <div class="password-field">
    <input class="field-input" [class.field-error]="form.controls['new_password'].invalid && form.controls['new_password'].touched"
           [formControl]="$any(form.controls['new_password'])" [type]="hideNew ? 'password' : 'text'"
           autocomplete="new-password">
    <mat-icon class="password-toggle" (click)="hideNew = !hideNew"
              [attr.aria-label]="hideNew ? 'Passwort anzeigen' : 'Passwort verbergen'"
              role="button" tabindex="0"
              (keydown.enter)="hideNew = !hideNew" (keydown.space)="$event.preventDefault(); hideNew = !hideNew">
      {{ hideNew ? 'visibility_off' : 'visibility' }}
    </mat-icon>
  </div>
  @if (form.controls['new_password'].hasError('required') && form.controls['new_password'].touched) {
    <p class="validation-error">Neues Passwort ist ein Pflichtfeld.</p>
  }
  @if (form.controls['new_password'].hasError('minlength') && form.controls['new_password'].touched) {
    <p class="validation-error">Das Passwort muss mindestens 8 Zeichen lang sein.</p>
  }

  <label class="field-label">Neues Passwort bestätigen*</label>
  <div class="password-field">
    <input class="field-input" [class.field-error]="form.controls['confirm_password'].invalid && form.controls['confirm_password'].touched"
           [formControl]="$any(form.controls['confirm_password'])" [type]="hideConfirm ? 'password' : 'text'"
           autocomplete="new-password">
    <mat-icon class="password-toggle" (click)="hideConfirm = !hideConfirm"
              [attr.aria-label]="hideConfirm ? 'Passwort anzeigen' : 'Passwort verbergen'"
              role="button" tabindex="0"
              (keydown.enter)="hideConfirm = !hideConfirm" (keydown.space)="$event.preventDefault(); hideConfirm = !hideConfirm">
      {{ hideConfirm ? 'visibility_off' : 'visibility' }}
    </mat-icon>
  </div>
  @if (form.controls['confirm_password'].hasError('required') && form.controls['confirm_password'].touched) {
    <p class="validation-error">Bitte bestätige dein neues Passwort.</p>
  }

  @if (passwordMismatch && form.controls['confirm_password'].touched) {
    <p class="validation-error">Die Passwörter stimmen nicht überein.</p>
  }

  @if (errorMessage) {
    <div class="error-message">{{ errorMessage }}</div>
  }

  @if (successMessage) {
    <div class="success-message">{{ successMessage }}</div>
  }
</div>
<div class="dialog-footer">
  <button class="dialog-save-btn" (click)="save()" [disabled]="form.invalid || passwordMismatch || isLoading">
    @if (isLoading) {
      Wird gespeichert...
    } @else {
      Passwort ändern
    }
  </button>
</div>
